import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  virtualHumanTalkingSelector,
  markedToCompleteWhenFinishedTalkingSelector,
  completeSession,
  selectChatState,
  ChatStates,
  promptDiagnosis,
  setPostObjectivesCompletePromptActive,
  markedToShowEndConversationPromptWhenFinishedTalkingSelector,
  setConversationCompletePromptActive,
} from '../../../../slices/chat/ChatSlice';
import { virtualHumanDataSelector } from '../../../../slices/VirtualHumanSlice';
import { patientSelector } from '../../../../slices/PatientSlice';

// created this because hooks can't be conditionally called (components can, obviously)
const RootDefaultBehaviorHandler = (props) => {
  const virtualHumanTalking = useSelector(virtualHumanTalkingSelector);
  const vh = useSelector(virtualHumanDataSelector);
  const vhDBVH = useSelector(patientSelector);

  const markedToCompleteWhenFinishedTalking = useSelector(
    markedToCompleteWhenFinishedTalkingSelector
  );
  const dispatch = useDispatch();
  const chatState = useSelector(selectChatState);

  // complete if marked to complete and vh finishes talking
  const markedComplete = useRef(false);
  useEffect(() => {
    if (
      !markedComplete.current &&
      markedToCompleteWhenFinishedTalking &&
      !virtualHumanTalking &&
      chatState === ChatStates.TALK
    ) {
      markedComplete.current = true;
      dispatch(setPostObjectivesCompletePromptActive(true));
      // if (vh.Type === 'medical' && !vhDBVH.disableDiagnosis) {
      //   dispatch(promptDiagnosis());
      // } else {
      //   dispatch(
      //     completeSession({
      //       patientId: vh.ExternalID,
      //     })
      //   );
      // }
    }
  }, [
    dispatch,
    markedToCompleteWhenFinishedTalking,
    virtualHumanTalking,
    vh?.ExternalID,
    chatState,
    vh?.Type,
    vhDBVH?.disableDiagnosis,
  ]);

  const markedToShowEndConversationPromptWhenFinishedTalking = useSelector(
    markedToShowEndConversationPromptWhenFinishedTalkingSelector
  );

  // complete if marked to complete and vh finishes talking
  useEffect(() => {
    if (
      markedToShowEndConversationPromptWhenFinishedTalking &&
      !virtualHumanTalking &&
      chatState === ChatStates.TALK
    ) {
      dispatch(setConversationCompletePromptActive(true));
    }
  }, [
    dispatch,
    markedToShowEndConversationPromptWhenFinishedTalking,
    virtualHumanTalking,
    vh?.ExternalID,
    chatState,
    vh?.Type,
    vhDBVH?.disableDiagnosis,
  ]);

  return <></>;
};

export default RootDefaultBehaviorHandler;
